var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Splash'),_c('div',{staticClass:"contain-top-widgets cc-txt-center columns"},[_c('Clock'),_c('GoogleInsight'),_c('Compta')],1),_c('Phone'),_c('Nagios')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }